<template>
  <div class="dashboard-page-wrapper test-page">
    
    <div class="top-wrap">
      <div class="text-img">
        <h2>{{ testType }}</h2>
        <div>
          <div @click="downloadPDF()" class="test-pdf-div">
            <div class="img-content">
              <v-img src="../../assets/Svg/pdfIcon.svg" alt="PDF Icon" width="24" height="24"></v-img>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Top Content Section (Test Parameters) -->
      <div class="top-content">
        <v-img src="../../assets/Images/Assets/top image.png" alt="test image" width="49px" height="49px"></v-img>
        <div class="fields-info">
          <div
            class="fields-info-wrap"
            :style="{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: '16px'
            }"
          >
            <div class="field-item">
              <p style="margin: 0; font-weight: 500;" class="field-label">Test Temperature</p>
              <p class="test-top-values" style="margin: 0;">
                <span class="value-text">{{ testData.testTemperature }}</span>
                <span class="uom">&nbsp;F</span>
              </p>
            </div>
            <div class="field-item">
              <p style="margin: 0; font-weight: 500;" class="field-label">solutionGORMeasured</p>
              <p class="test-top-values" style="margin: 0;">
                <span class="value-text">{{ testData.solutionGORMeasured }}</span>
                <span class="uom">&nbsp;kg/cc</span>
              </p>
            </div>
            <div class="field-item">
              <p style="margin: 0; font-weight: 500;" class="field-label">Sample ID</p>
              <p class="test-top-values" style="margin: 0;">
                <span class="value-text">{{ testData.sampleId }}</span>
              </p>
            </div>
            <div class="field-item">
              <p style="margin: 0; font-weight: 500;" class="field-label">Oil Compressibility @ Psat-CCE</p>
              <p class="test-top-values" style="margin: 0;">
                <span class="value-text">{{ testData.oilCompressibility }}</span>
                <span class="uom">&nbsp;10^-6/psi</span>
              </p>
            </div>
            <div class="field-item">
              <p style="margin: 0; font-weight: 500;" class="field-label">Fluid Type</p>
              <p class="test-top-values" style="margin: 0;">
                <span class="value-text">{{ testData.fluidType }}</span>
              </p>
            </div>
            <div class="field-item">
              <p style="margin: 0; font-weight: 500;" class="field-label">Saturation Pressure</p>
              <p class="test-top-values" style="margin: 0;">
                <span class="value-text">{{ testData.saturationPressure }}</span>
                <span class="uom">&nbsp;psi</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Status and Tabs Section -->
    <div class="status-tabs-section">
      <div class="tabs-container">
        <v-tabs v-model="activeTab" color="primary" class="test-tabs">
          <v-tab value="table">Table</v-tab>
          <v-tab value="plots">Plots</v-tab>
        </v-tabs>
      </div>
      <div class="status-indicator">
        <v-btn 
          :class="statusButtonClass"
          @click="openQCStatusModal"
        >
          {{ statusText }}
        </v-btn>
      </div>
    </div>

    <!-- Validation Checkboxes Section -->
    <div class="validation-section">
      <div class="validation-checkboxes">
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Pressure Monotonically decreases</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.pressureMonotonic" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Vrel Monotonically Increases</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.vrelMonotonic" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Vrel 3-Digits Precision</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.vrelPrecision" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Vrel Single- and Two-Phase</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.vrelPhase" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Vrel at Psat = 1</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.vrelPsat" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Vrel Above 2</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.vrelAbove2" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">VVrel Reported</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.vrelReported" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Oil Density: 0.5-0.7 g/cm3</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.oilDensity" hide-details class="square-checkbox"></v-checkbox>
          </div>
        </div>
        <div class="validation-card">
          <div class="validation-row">
            <span class="validation-label">Y-Function</span>
            <v-tooltip location="top" content-class="info-tooltip">
              <template v-slot:activator="{ props }">
                <v-img 
                  v-bind="props"
                  src="../../assets/Svg/infoIcon.svg" 
                  class="info-icon"
                  width="18"
                  height="18"
                  alt="Info"
                />
              </template>
              <span>Click for more information about this validation</span>
            </v-tooltip>
            <v-checkbox v-model="validationChecks.yFunction" hide-details class="square-checkbox"></v-checkbox>
            <div class="calculate-button">
        <v-btn color="primary">Calculate</v-btn>
      </div>
          </div>
        </div>
      </div>
      
    </div>

    <!-- QC Status Modal -->
    <v-dialog v-model="showQCStatusModal" max-width="400">
      <v-card class="qc-confirmation-modal">
        <v-card-title class="modal-title">
          QC Status Review
        </v-card-title>
        
        <v-divider class="modal-divider"></v-divider>
        
        <v-card-text class="modal-content">
          <div class="confirmation-message">
            <span v-if="testStatus === 'passed'">
              Are you sure you want to change the QC status from Pass to Fail?
            </span>
            <span v-else-if="testStatus === 'failed'">
              Are you sure you want to change the QC status from Fail to Pass?
            </span>
            <span v-else>
              Please select the QC status for this test:
            </span>
          </div>
          
          <div class="test-info">
            <div class="info-item">
              <strong>Test:</strong> {{ testType }}
            </div>
            <div class="info-item">
              <strong>Sample ID:</strong> {{ testData.sampleId }}
            </div>
          </div>
        </v-card-text>
        
        <v-card-actions class="modal-actions">
          <v-btn 
            variant="outlined" 
            @click="showQCStatusModal = false"
            class="cancel-btn"
          >
            Cancel
          </v-btn>
          
          <!-- Show QC Fail button only if current status is passed -->
          <v-btn 
            v-if="testStatus === 'passed'"
            color="error" 
            @click="handleQCStatusChange('fail')"
            :loading="isSubmittingQCStatus"
            class="action-btn fail-btn"
          >
            <v-icon left>mdi-close</v-icon>
            QC Fail
          </v-btn>
          
          <!-- Show QC Pass button only if current status is failed -->
          <v-btn 
            v-if="testStatus === 'failed'"
            color="success" 
            @click="handleQCStatusChange('pass')"
            :loading="isSubmittingQCStatus"
            class="action-btn pass-btn"
          >
            <v-icon left>mdi-check</v-icon>
            QC Pass
          </v-btn>
          
          <!-- Show both buttons only if status is pending -->
          <template v-if="testStatus === 'pending'">
            <v-btn 
              color="success" 
              @click="handleQCStatusChange('pass')"
              :loading="isSubmittingQCStatus"
              class="action-btn pass-btn"
            >
              <v-icon left>mdi-check</v-icon>
              QC Pass
            </v-btn>
            
            <v-btn 
              color="error" 
              @click="handleQCStatusChange('fail')"
              :loading="isSubmittingQCStatus"
              class="action-btn fail-btn"
            >
              <v-icon left>mdi-close</v-icon>
              QC Fail
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Table Tab Content -->
    <div v-if="activeTab === 'table'" class="table-content">
      <div class="table-wrap">
        <div class="table-title-div">
          <p class="table-title">{{ testType }}</p>
          <div class="csv-btn-test" >
            <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
          </div>
        </div>
         <v-table class="test-data-table">
        <thead>
          <tr class="main-header-detail">
            <th class="sticky-header-sub">Stage Test</th>
            <th class="sticky-header-sub">Saturation Pressure</th>
            <th class="sticky-header-sub">relativeVolumeRatio</th>
            <th class="sticky-header-sub">oDensity</th>
            <th class="sticky-header-sub">oilCompressibility</th>
          </tr>
          <tr class="sub-header">
            <th>-</th>
            <th>psi</th>
            <th>-</th>
            <th>g/cc</th>
            <th>10^-6/psi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td>{{ row.stageTest }}</td>
            <td>{{ row.saturationPressure }}</td>
            <td>{{ row.relativeVolumeRatio }}</td>
            <td>{{ row.oDensity || '-' }}</td>
            <td>{{ row.oilCompressibility || '-' }}</td>
          </tr>
        </tbody>
      </v-table>
      </div>
    </div>

    <!-- Plots Tab Content -->
    <div v-if="activeTab === 'plots'" class="plots-content">
      <div class="plots-navigation">
        <div class="plots-sidebar">
          <h4>Plots</h4>
          <div class="plot-types">
            <div 
              v-for="plotType in plotTypes" 
              :key="plotType.id"
              :class="['plot-type-item', { active: activePlotType === plotType.id }]"
              @click="activePlotType = plotType.id"
            >
              {{ plotType.name }}
            </div>
          </div>
        </div>
        
        <div class="plot-main-area">
         
          
          <div class="plot-container">
            <div class="plot-placeholder">
              <v-icon size="x-large" color="grey">mdi-chart-line</v-icon>
              <p>Plot visualization will be rendered here</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestDetailView",
  data() {
    return {
      activeTab: 'table',
      activePlotType: 'relativeVolume',
      testType: 'Constant Composition Expansion',
      testData: {
        testTemperature: '110.0',
        solutionGORMeasured: '0.777',
        sampleId: '10124',
        oilCompressibility: '10.1244',
        fluidType: 'Oil',
        saturationPressure: '1967'
      },
      validationChecks: {
        pressureMonotonic: false,
        vrelMonotonic: false,
        vrelPrecision: false,
        vrelPhase: false,
        vrelPsat: false,
        vrelAbove2: false,
        vvrelReported: false,
        oilDensity: false,
        yFunction: false
      },
      documentDownload: require("../../assets/Images/csv.svg"),
      tableData: [
        { stageTest: 1, saturationPressure: 5015, relativeVolumeRatio: 0.9572, oDensity: 0.7778, oilCompressibility: 10.1244 },
        { stageTest: 2, saturationPressure: 5000, relativeVolumeRatio: 0.9573, oDensity: 0.7776, oilCompressibility: 10.1287 },
        { stageTest: 3, saturationPressure: 4500, relativeVolumeRatio: 0.9580, oDensity: 0.7770, oilCompressibility: 10.1400 },
        { stageTest: 4, saturationPressure: 4000, relativeVolumeRatio: 0.9588, oDensity: 0.7762, oilCompressibility: 10.1550 },
        { stageTest: 5, saturationPressure: 3500, relativeVolumeRatio: 0.9598, oDensity: 0.7750, oilCompressibility: 10.1750 },
        { stageTest: 6, saturationPressure: 3000, relativeVolumeRatio: 0.9610, oDensity: 0.7735, oilCompressibility: 10.2000 },
        { stageTest: 7, saturationPressure: 2500, relativeVolumeRatio: 0.9625, oDensity: 0.7715, oilCompressibility: 10.2350 },
        { stageTest: 8, saturationPressure: 2000, relativeVolumeRatio: 0.9645, oDensity: 0.7690, oilCompressibility: 10.2800 },
        { stageTest: 9, saturationPressure: 1500, relativeVolumeRatio: 0.9670, oDensity: 0.7660, oilCompressibility: 10.3400 },
        { stageTest: 10, saturationPressure: 1000, relativeVolumeRatio: 0.9705, oDensity: 0.7620, oilCompressibility: 10.4200 },
        { stageTest: 11, saturationPressure: 500, relativeVolumeRatio: 1.0000, oDensity: 0.7550, oilCompressibility: 10.5500 },
        { stageTest: 12, saturationPressure: 219, relativeVolumeRatio: 3.4040, oDensity: null, oilCompressibility: null },
        { stageTest: 13, saturationPressure: 200, relativeVolumeRatio: 3.5000, oDensity: null, oilCompressibility: null }
      ],
      plotTypes: [
        { id: 'relativeVolume', name: 'Relative Volume' },
        { id: 'oilDensity', name: 'Oil Density' },
        { id: 'oilCompressibility', name: 'Oil Compressibility' },
        { id: 'yFunction', name: 'Y-Function' }
      ],
      // QC Status properties
      showQCStatusModal: false,
      isSubmittingQCStatus: false,
      testStatus: 'pending' // 'pending', 'passed', 'failed'
    };
  },
  computed: {
    statusButtonClass() {
      switch (this.testStatus) {
        case 'passed': return 'status-passed';
        case 'failed': return 'status-failed';
        case 'pending': 
        default: return 'status-pending';
      }
    },
    statusText() {
      switch (this.testStatus) {
        case 'passed': return 'QC Passed';
        case 'failed': return 'QC Failed';
        case 'pending': 
        default: return 'Pending';
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    downloadPDF() {
      console.log('Downloading PDF...');
      // Implement PDF download functionality
    },
    getActivePlotTypeName() {
      const activePlot = this.plotTypes.find(plot => plot.id === this.activePlotType);
      return activePlot ? activePlot.name : 'Relative Volume';
    },
    updateTestData() {
      // Update test data based on test type
      switch (this.testType) {
        case 'Sample Validation':
          this.testData = {
            testTemperature: '95.0',
            solutionGORMeasured: '0.650',
            sampleId: 'SMP-001',
            oilCompressibility: '8.5000',
            fluidType: 'Oil',
            saturationPressure: '1850'
          };
          this.plotTypes = [
            { id: 'sampleQuality', name: 'Sample Quality' },
            { id: 'validationMetrics', name: 'Validation Metrics' }
          ];
          break;
        case 'CCE Test':
          this.testData = {
            testTemperature: '110.0',
            solutionGORMeasured: '0.777',
            sampleId: '10124',
            oilCompressibility: '10.1244',
            fluidType: 'Oil',
            saturationPressure: '1967'
          };
          this.plotTypes = [
            { id: 'relativeVolume', name: 'Relative Volume' },
            { id: 'oilDensity', name: 'Oil Density' },
            { id: 'oilCompressibility', name: 'Oil Compressibility' },
            { id: 'yFunction', name: 'Y-Function' }
          ];
          break;
        case 'Viscosity Test':
          this.testData = {
            testTemperature: '120.0',
            solutionGORMeasured: '0.850',
            sampleId: 'VIS-002',
            oilCompressibility: '12.5000',
            fluidType: 'Oil',
            saturationPressure: '2200'
          };
          this.plotTypes = [
            { id: 'viscosityCurve', name: 'Viscosity Curve' },
            { id: 'temperatureEffect', name: 'Temperature Effect' }
          ];
          break;
        case 'DL Test':
          this.testData = {
            testTemperature: '105.0',
            solutionGORMeasured: '0.720',
            sampleId: 'DL-003',
            oilCompressibility: '9.8000',
            fluidType: 'Gas',
            saturationPressure: '1800'
          };
          this.plotTypes = [
            { id: 'liberationCurve', name: 'Liberation Curve' },
            { id: 'gasComposition', name: 'Gas Composition' }
          ];
          break;
        case 'CVD Test':
          this.testData = {
            testTemperature: '115.0',
            solutionGORMeasured: '0.800',
            sampleId: 'CVD-004',
            oilCompressibility: '11.2000',
            fluidType: 'Oil',
            saturationPressure: '2100'
          };
          this.plotTypes = [
            { id: 'volumeDepletion', name: 'Volume Depletion' },
            { id: 'pressureEffect', name: 'Pressure Effect' }
          ];
          break;
        case 'Separator Test':
          this.testData = {
            testTemperature: '100.0',
            solutionGORMeasured: '0.750',
            sampleId: 'SEP-005',
            oilCompressibility: '10.0000',
            fluidType: 'Oil',
            saturationPressure: '1900'
          };
          this.plotTypes = [
            { id: 'separatorEfficiency', name: 'Separator Efficiency' },
            { id: 'phaseBehavior', name: 'Phase Behavior' }
          ];
          break;
        case 'Composition':
          this.testData = {
            testTemperature: '98.0',
            solutionGORMeasured: '0.680',
            sampleId: 'COMP-006',
            oilCompressibility: '9.2000',
            fluidType: 'Gas',
            saturationPressure: '1750'
          };
          this.plotTypes = [
            { id: 'compositionChart', name: 'Composition Chart' },
            { id: 'molecularWeight', name: 'Molecular Weight' }
          ];
          break;
        default:
          // Default data for unknown test types
          this.testData = {
            testTemperature: '100.0',
            solutionGORMeasured: '0.700',
            sampleId: 'TEST-000',
            oilCompressibility: '10.0000',
            fluidType: 'Oil',
            saturationPressure: '2000'
          };
          this.plotTypes = [
            { id: 'defaultPlot', name: 'Default Plot' }
          ];
      }
    },
    // QC Status methods
    openQCStatusModal() {
      this.showQCStatusModal = true;
    },
    async handleQCStatusChange(status) {
      this.isSubmittingQCStatus = true;
      
      try {
        // Get required data from localStorage
        const sampleId = localStorage.getItem("sampleId");
        const testId = localStorage.getItem("testId");
        const tenantId = localStorage.getItem("tenantId");
        const authToken = localStorage.getItem("authToken");
        
        if (!sampleId || !testId || !tenantId || !authToken) {
          console.error('Missing required data for QC status change');
          return;
        }
        
        // Prepare the API payload
        const payload = {
          sampleID: sampleId,
          testName: this.testType.toLowerCase().replace(/\s+/g, ''), // Convert to lowercase and remove spaces
          testID: testId,
          case: "is_passed",
          value: status === 'pass' ? 1 : 0
        };
        
        console.log('Submitting QC status change:', payload);
        
        // Make API call
        const response = await this.$api.post('/public/api/samples/qc/feedback', payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
            'tenantId': tenantId
          }
        });
        
        if (response && response.data) {
          console.log('QC status change successful:', response.data);
          
          // Update local status
          this.testStatus = status === 'pass' ? 'passed' : 'failed';
          
          // Close modal
          this.showQCStatusModal = false;
          
          // Show success message (optional)
          console.log(`QC status changed to: ${this.statusText}`);
        }
      } catch (error) {
        console.error('Error changing QC status:', error);
        // Handle error (you could show a toast notification here)
      } finally {
        this.isSubmittingQCStatus = false;
      }
    }
  },
  mounted() {
    // Get test type from route params if available
    if (this.$route.params.testType) {
      this.testType = this.$route.params.testType;
      this.updateTestData();
    }
  }
};
</script>

<style scoped>

.test-pdf-div {
    width: 32px;
    height: 32px;
}

.test-pdf-div:hover {
  background-color: #f5f5f5;
}


.pdf-text {
  font-size: 14px;
  color: #666;
}

.status-tabs-section {
  background: white;
  border-radius: 8px;
  padding: 10px 10px;
  margin-bottom: 20px;
  margin-top: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  width: 89px;
  height: 32px;
  border-radius: 6px;
  opacity: 1;
  gap: 4px;
  padding: 4px 8px;
}

.status-indicator .v-btn {
  width: 89px;
  height: 32px;
  border-radius: 6px;
  opacity: 1;
  gap: 4px;
  padding: 4px 8px;
  min-width: 89px;
  background-color: #22C55E !important;
  color: white !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.6px;
  text-align: center;
  vertical-align: middle;
  text-transform: none !important;
}

.test-tabs {
  flex: 1;
}

/* Responsive, backgroundless validation section */
.validation-section {
  /* Remove background, border, and box-shadow */
  background: none;
  border-radius: 0;
  padding: 0 0 20px 0;
  margin-bottom: 20px;
  box-shadow: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
}

.validation-checkboxes {
  flex: 1 1 0;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  width: 100%;
}

@media (max-width: 1200px) {
  .validation-checkboxes {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 900px) {
  .validation-checkboxes {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .validation-section {
    flex-direction: column;
    gap: 16px;
    padding: 0 0 16px 0;
  }
  .validation-checkboxes {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .calculate-button {
    margin-left: 0 !important;
    margin-top: 16px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

.validation-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 0;
  padding: 0;
  border: 1px solid #e0e0e0;
  border-radius: 7px;
  background-color: #ffffff;
  transition: all 0.2s ease;
  text-align: left;
  height: 50px;
  width: 100%;
  box-sizing: border-box;
  opacity: 1;
  /* Remove extra padding, handled in .validation-row */
}

.validation-card:hover {
  background-color: #f1f3f4;
  border-color: #dadce0;
}

.validation-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 0 10px 0 12px;
  gap: 8px;
  box-sizing: border-box;
}

.validation-label {
  font-size: 12px;
  font-weight: 400;
  color: #202124;
  line-height: 1.2;
  text-align: left;
  word-wrap: break-word;
  max-width: 70%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1 1 auto;
}

.info-icon {
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s ease;
  margin-left: 8px;
  margin-right: 8px;
}

.info-icon:hover {
  opacity: 0.7;
}

.info-tooltip {
  background-color: #333 !important;
  color: white !important;
  font-size: 12px !important;
  padding: 8px 12px !important;
  border-radius: 4px !important;
  max-width: 200px !important;
}

.validation-row .v-radio {
  margin-left: auto;
  flex-shrink: 0;
  /* To align radio to far right */
}

 .calculate-button {
   display: flex;
   align-items: flex-end;
 }

 .v-selection-control__input {
   margin-left: 30px;
 }

 .square-checkbox {
   margin-left: 0;
   flex-shrink: 0;
 }

 :deep(.square-checkbox .v-selection-control__wrapper) {
    margin-left: auto !important;
   border-radius: 8px !important;
 }

 :deep(.square-checkbox .v-selection-control__wrapper .v-selection-control__input) {
   border-radius: 8px !important;
   width: 18px !important;
   height: 18px !important;
 }

 :deep(.square-checkbox .v-selection-control__wrapper .v-selection-control__input::before) {
   border-radius: 8px !important;
   width: 18px !important;
   height: 18px !important;
 }

 :deep(.square-checkbox .v-selection-control__wrapper .v-selection-control__input::after) {
   border-radius: 8px !important;
   width: 10px !important;
   height: 10px !important;
 }

 .calculate-button .v-btn {
   width: 79px;
   height: 32px;
   border-radius: 6px;
   opacity: 1;
   gap: 4px;
   padding: 4px 8px;
   min-width: 79px;
   font-weight: 500;
   font-size: 14px;
   line-height: 24px;
   letter-spacing: -0.6px;
   text-align: center;
   vertical-align: middle;
   text-transform: none !important;
 }


.main-header-detail {
  position: sticky;
  top: 48px !important;
  z-index: 1;
}

.main-header-detail th {
  background-color: rgba(34, 152, 213, 1) !important;
  color: white;
  font-weight: 600;
  padding: 16px 12px;
  text-align: center;
  position: sticky;
  top: 48px !important;
  z-index: 1;
  border-right: 1px solid #e0e0e0;
}

.sub-header {
  position: sticky;
  top: 96px;
  z-index: 1;
}

.sub-header th {
  background: #D6ECF6;
  color: #53545C;
  font-weight: 600;
  padding: 12px;
  text-align: center;
  position: sticky;
  top: 96px !important;
  z-index: 8;
  border-right: 1px solid #e0e0e0;
}


.test-data-table tbody td {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  text-align: center;
}

.test-data-table tbody tr:hover {
  background-color: #f8f9fa;
}

.plots-content {
  min-height: 600px;
}
.sticky-header-sub{
    position: sticky;
    top: 0px;
    z-index: 1;
}


.plots-navigation {
  display: flex;
  gap: 24px;
}

.plots-sidebar {
  width: 200px;
  background-color: #ffffff;
  flex-shrink: 0;
}

.plots-sidebar h4 {
  margin: 16px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.plot-types {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.plot-type-item {
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 14px;
}

.plot-type-item:hover {
  background-color: #f5f5f5;
}

.plot-type-item.active {
  background-color: #e3f2fd;
  color: #333;
  font-weight: 500;
}

.plot-main-area {
  flex: 1;
  width: 1556px;
  height: 747px;
  opacity: 1;
  gap: 16px;
}

.plot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.plot-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.plot-controls {
  display: flex;
  gap: 8px;
}

.plot-container {
  border: 0.67px solid #e0e0e0;
  border-radius: 10.73px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  width: 100%;
}

.plot-placeholder {
  text-align: center;
  color: #666;
}

.plot-placeholder p {
  margin: 8px 0 0 0;
  font-size: 14px;
}
.csv-btn-test{
  width: 35px;
  height: 35px;
  border-radius: 4px;
  transform: rotate(0deg);
  opacity: 1;
  border-width: 1px;
  border-style: solid;
  border-color: #e0e0e0;
  background: #fff;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Responsive styles for top content section */
@media (max-width: 1200px) {
  .fields-info-wrap {
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 12px !important;
  }
}

@media (max-width: 900px) {
  .fields-info-wrap {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 10px !important;
  }
  
  .top-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
  }
  
  .fields-info {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .fields-info-wrap {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }
  
  .top-wrap {
    padding: 16px;
  }
  
  .text-img h2 {
    font-size: 20px;
  }
  
  .field-item {
    padding: 8px;
  }
  
  .field-label {
    font-size: 12px;
  }
  
  .test-top-values {
    font-size: 14px;
  }
}

/* QC Status Button Styles */
.status-indicator .status-passed {
  background-color: #DCFCE7 !important;
  color: #000000 !important;
}

.status-indicator .status-failed {
  background-color: #FCA5A5 !important;
  color: #000000 !important;
}

.status-indicator .status-pending {
  background-color: #0000000D !important;
  color: #000000 !important;
}

/* QC Confirmation Modal Styles */
.qc-confirmation-modal {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.modal-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #1a1a1a !important;
  text-align: center !important;
  padding: 24px 24px 16px 24px !important;
  margin: 0 !important;
}

.modal-divider {
  margin: 0 !important;
  border-color: #e5e7eb !important;
}

.modal-content {
  padding: 24px !important;
}

.confirmation-message {
  font-size: 16px !important;
  color: #374151 !important;
  text-align: center !important;
  margin-bottom: 20px !important;
  line-height: 1.5 !important;
}

.test-info {
  background-color: #f9fafb !important;
  border-radius: 8px !important;
  padding: 16px !important;
  margin-top: 16px !important;
}

.info-item {
  margin-bottom: 8px !important;
  font-size: 14px !important;
  color: #4b5563 !important;
}

.info-item:last-child {
  margin-bottom: 0 !important;
}

.info-item strong {
  color: #1f2937 !important;
  font-weight: 600 !important;
}

.modal-actions {
  padding: 16px 24px 24px 24px !important;
  justify-content: space-between !important;
  gap: 12px;
}

.cancel-btn {
  border-color: #d1d5db !important;
  color: #6b7280 !important;
  font-weight: 500 !important;
}

.action-btn {
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}

.pass-btn {
  background-color: #22C55E !important;
  color: white !important;
}

.fail-btn {
  background-color: #E53535 !important;
  color: white !important;
}
</style>
